export default __webpack_public_path__ + "static/AndroidMockup-c54e6fde79cbfd7d32d81e6967cfcf9d.png";